import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import EarthingFaultComponent from '../../components/EarthingFaultComponent/EarthingFaultComponent'

const EarthingFault = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <EarthingFaultComponent/>
                </div>
            </div>
        </div>
    )
}

export default EarthingFault
